import { render, staticRenderFns } from "./ChangeLanguageIconSp.vue?vue&type=template&id=6e67e79c&scoped=true&"
import script from "./ChangeLanguageIconSp.vue?vue&type=script&lang=ts&"
export * from "./ChangeLanguageIconSp.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeLanguageIconSp.vue?vue&type=style&index=0&id=6e67e79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67e79c",
  null
  
)

export default component.exports